import api from './axios';

export const getCsrf = () => api.get('/sanctum/csrf-cookie'); // sets cookies
export const login = (payload) => api.post('/login', payload);
export const logout = () => api.post('/logout');
export const me = () => api.get('/api/user');
